
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.592 10.662a16.251 16.251 0 01-2.448-5.911 2.4 2.4 0 00-1.894-1.893A16.257 16.257 0 0113.339.409a2.4 2.4 0 00-2.677 0A16.257 16.257 0 014.75 2.858a2.4 2.4 0 00-1.893 1.893 16.251 16.251 0 01-2.449 5.911 2.4 2.4 0 000 2.677 16.251 16.251 0 012.448 5.911 2.4 2.4 0 001.894 1.894 16.254 16.254 0 015.911 2.449 2.4 2.4 0 002.677 0 16.254 16.254 0 015.911-2.449 2.4 2.4 0 001.893-1.893 16.251 16.251 0 012.448-5.911 2.4 2.4 0 00.002-2.678zM22.034 12.3a18.115 18.115 0 00-2.73 6.59.531.531 0 01-.419.419 18.119 18.119 0 00-6.59 2.73.531.531 0 01-.592 0 18.118 18.118 0 00-6.59-2.73.53.53 0 01-.419-.419 18.121 18.121 0 00-2.73-6.59.531.531 0 010-.592A18.122 18.122 0 004.7 5.115a.53.53 0 01.414-.415 18.121 18.121 0 006.59-2.73.531.531 0 01.592 0 18.122 18.122 0 006.59 2.73.53.53 0 01.419.418 18.119 18.119 0 002.73 6.59.531.531 0 01-.001.592zM16.35 8.977l-7.374 7.374a.937.937 0 01-1.326-1.326l7.374-7.374a.937.937 0 011.326 1.326zm-5.256-.663a2.781 2.781 0 10-2.781 2.781 2.784 2.784 0 002.781-2.781zm-3.687 0a.906.906 0 11.906.906.907.907 0 01-.906-.906zm8.28 4.593a2.781 2.781 0 102.781 2.781 2.784 2.784 0 00-2.781-2.781zm0 3.687a.906.906 0 11.906-.906.907.907 0 01-.906.906zm0 0"}})])
          )
        }
      }
    